/**
 * Thrown when the user backs out of a confirmation raised while saving a booking.
 * The booking form treats it as "stay where you are": no error message, and the
 * form is left open with the user's changes intact.
 */
export class BookingSaveCancelledError extends Error {
  constructor() {
    super('Booking save cancelled by the user');
    this.name = 'BookingSaveCancelledError';
  }
}
